import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getExtractionConfigurationsQueryKey } from "Configurations/Api/Queries/useExtractionConfigurationsQuery";
import { deleteExtractionConfiguration } from "Infrastructure/Api/Api";

export function useDeleteExtractionConfigurationMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id: number) => deleteExtractionConfiguration(id),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [getExtractionConfigurationsQueryKey(0, 100)],
			});
		},
	});
}
